import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { COLOR } from 'config';
import Text from 'components/Text';

import Card from './Card';
import { ImageCardContainer } from './ImageCard';
import Title from './Title';
import image from '../images/FB-Landing-Page-graphic2b.png';
import Button from './Button';


const StyledText = styled(Text)`
  line-height:2.35rem;
`;

const StyledButton = styled(Button)`
  //color:${COLOR.white};
  background-color:${COLOR.base};
  border-radius:5px;
  padding: 12px 24px;
  padding-bottom: 13px;
  color: white;
  line-height: 1 !important;
  font-weight: bold;
  &:hover{
    background-color:${COLOR.base};
  }
`;

const JoinNow = () => {
  const icon = (
    <ImageCardContainer
      image={image}
      height="474px"
      width="480"
      backgroundColor={COLOR.base}
      backgroundPositionY={'20px'}
    />
  );

  return (
    <Card image={icon} mb={'3rem'} noMargin>
      <Title id="Joining the Facebook Skycoin NYC Group" />
      <StyledText>
        <FormattedHTMLMessage id="Head on over to the Skycoin <a style='color: blue' src='https://www.facebook.com/groups/SkycoinNYC/'>NYC Facebook group </a> and join the group to stay abreast of the latest developments in the Sky universe and connect with the NYC Skyfleet. The team posts original content that is pertinent and insightful. If you care about net neutrality and on-line privacy, this is the place to be." />
      </StyledText>
      <StyledButton to="https://www.facebook.com/groups/SkycoinNYC/" width={['100%', 'auto', 'auto']}>
        <FormattedMessage id="Join Now" />
      </StyledButton>
    </Card>
  );
};

export default JoinNow;



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/components/JoinNow.js